import { render } from "./previewImage.vue?vue&type=template&id=0737c96a&scoped=true"
import script from "./previewImage.vue?vue&type=script&lang=js"
export * from "./previewImage.vue?vue&type=script&lang=js"

import "./previewImage.vue?vue&type=style&index=0&id=0737c96a&scoped=true&lang=scss"

import exportComponent from "/root/workspace/xxzx-website-county_fx0Z/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0737c96a"]])

export default __exports__